import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/config'
const plural = 'files'
const single = 'file'

const config = new ApiCore({
	index: true,
    upload: true,
	url: url,
	plural: plural,
	single: single,
	create: true
})

config.checkStatus = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/status`)
		.then(handleResponse)
		.catch(handleError);
}

config.checkAttachment = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/attachment`)
		.then(handleResponse)
		.catch(handleError);
}

config.saveAttachment = (payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/attachment`, payload)
		.then(handleResponse)
		.catch(handleError);
}

export default config
